import BaseReducer from "../BaseReducer";

export default class AvatarsReducer extends BaseReducer {
  initialState = {
    avatars: [],
    loading: false,
  };
}
